import { EN_MESSAGES } from './locales/en';

export type MessageKey = keyof typeof EN_MESSAGES;

export function isMessageKey(value: string): value is MessageKey {
  return Object.prototype.hasOwnProperty.call(EN_MESSAGES, value);
}
